import { css } from 'styled-components';

export const plainLinkStyle = css`
  text-decoration: none;
  filter: none;
`;
